<template>
    <div>
      <v-card>
        <v-card-title>Transmitir Guia a FedEx</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-combobox
                v-model="servicio"
                :items="servicios"
                item-text="descripcion"
                item-value="servicio"
                label="Servicio"
                append-icon="check_circle"
                return-object
                :disabled="disableAll"
              ></v-combobox>
            </v-col>
          </v-row>
          <v-row>
          <v-col cols="12" sm="12" md="12">
              <v-combobox
                v-model="cuenta"
                :items="cuentas"
                item-text="nombre"
                item-value="cuenta"
                label="Cuenta"
                append-icon="check_circle"
                return-object
                :disabled="disableAll"
              ></v-combobox>
              <div v-if="cuenta">{{ cuenta.cuenta }}</div>
            </v-col>
          </v-row>
          <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-checkbox
              v-model="enviarDatosCliente"
              label="Deseo transmitir los datos del cliente para la creación de la guia en DHL"
              :disabled="disableAll"
              @change="handleEnviarDatosChange()"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-combobox
              v-model="empresa"
              :items="empresas"
              item-text="empresa"
              item-value="id"
              label="Empresa"
              append-icon="mdi-office-building"
              return-object
              :disabled="disableAll"
              v-show="!enviarDatosCliente"
              clearable
            ></v-combobox>
          </v-col>
        </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer><v-btn :disabled="disableAll" color="primary" @click="enviarFedEx()"> Enviar a FedEx </v-btn>
        </v-card-actions>
      </v-card>
      <v-overlay :value="overlay">
         <waiting />
      </v-overlay>
    </div>
  </template>

  <script>
  import Waiting from '../components/Waiting.vue';
  import apicon from '../plugins/apicon';

  export default {
    props: {
        id : {
        type: Number,
        default: null,
      },
    },
    components: {
      Waiting,
    },
    created: function () {},
    data() {
      return {
        servicios: [
            {
                servicio: "FEDEX_INTERNATIONAL_PRIORITY_EXPRESS",
                descripcion: "FedEx International Priority Express"
            },
            {
                servicio: "INTERNATIONAL_FIRST",
                descripcion: "FedEx International First"
            },
            {
                servicio: "FEDEX_INTERNATIONAL_PRIORITY",
                descripcion: "FedEx International Priority"
            },
            {
                servicio: "INTERNATIONAL_ECONOMY",
                descripcion: "FedEx International Economy"
            }
        ],
        servicio: null,
        cuentas: [],
        cuenta: null,
        empresas: [],
        empresa: null,
        enviarDatosCliente: true,
        //generarFacturaComercial: false,
        overlay: false,
        disableAll: false,
      };
    },
    methods: {
      fillCuentas: function () {
      apicon.getDataApi(apicon.getApiBaseUrl() + 'cuentas/FedEx').then((result) => {
        this.cuentas = result;
      });
      },
      fillEmpresas: function() {
        apicon.getDataApi(apicon.getApiBaseUrl() + 'empresa').then((result) => {
          this.empresas = result;
        });
      },
      //Enviar guia a FedEx
      enviarFedEx: async function(){
          if(this.servicio != null){
              //this.$swal("Testing Function please wait for updates....");
              this.overlay = true;
              await apicon.saveDataApi(apicon.getApiBaseUrl() + 'enviarfedex',  {
                id: this.id,
                datosCliente : this.enviarDatosCliente,
                servicio: this.servicio.servicio,
                cuentaId : this.cuenta != null ? this.cuenta.id : null,
                empresaId : this.empresa != null ? this.empresa.id : null
                }).then((result) => {
                  if(result.status){
                    if (result.data.masterTrackingNumber) {
                      this.disableAll = true;
                      this.$swal("Se ha transmitido la información exitosamente su número de guía es : " + result.data.masterTrackingNumber);
                    }else if (result.errors){
                        let errStr = "";
                        result.errors.forEach(error => {
                          errStr = errStr + " " + "(" + error.code + ") " + error.message + ", "
                        });
                        this.$swal(errStr);
                        this.overlay = false;
                    }
                  }else{
                    let errorsStr = result.message + " : ";
                    result.errors.forEach(error => {
                      errorsStr = errorsStr + " " + "(" + error.code + ") " + error.message + ", "
                    });
                    this.$swal(errorsStr);
                  }
                  this.overlay = false;
              }).catch((err) => {
                if(err.errors){
                    let errStr = "";
                      err.errors.forEach(error => {
                        errStr = errStr + " " + "(" + error.code + ") " + error.message + ", "
                    });
                    this.$swal(errStr);
                    this.overlay = false;
                }
              });
          }else{
              this.$swal("Por favor seleccione un servicio para realizar el envío...");
          }
      },
      handleEnviarDatosChange: function(){
      if(!this.enviarDatosCliente){
        this.empresa = null;
      }
    },
    },
    mounted: async function () {
      apicon.setAuthHeaders();
      await this.fillCuentas();
      await this.fillEmpresas();
    },
  };
  </script>
